export default __webpack_public_path__ + "static/media/centro_andes_2_3.8171fd11.JPG";